"use strict";
/**
 * API Endpoints Configuration
 * Central location for all API endpoints used by CARBOwaste applications
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_RETRY_CONFIG = exports.CARBOWASTE_WEBPAGE_URL = exports.createCarboWasteEndpoints = exports.BdoEndpoints = exports.BDO_BASE_URL = void 0;
// BDO (Baza Danych o Odpadach) API Endpoints
exports.BDO_BASE_URL = "https://rejestr-bdo.mos.gov.pl/api/WasteRegister";
exports.BdoEndpoints = {
    Token: "".concat(exports.BDO_BASE_URL, "/v1/Auth/generateEupAccessToken"),
    GetEupIds: "".concat(exports.BDO_BASE_URL, "/v1/Auth/getEupList"),
    SearchKpo: "".concat(exports.BDO_BASE_URL, "/WasteTransferCard/v1/Kpo/sender/search"),
    KpoPrintingPage: "".concat(exports.BDO_BASE_URL, "/WasteTransferCard/v1/Kpo/printingpage"),
    KeoPrintingPage: "".concat(exports.BDO_BASE_URL, "/WasteRecordCard/v1/Keo/card/printingpage"),
    SearchKeo: "".concat(exports.BDO_BASE_URL, "/WasteRecordCard/v1/Keo/search"),
    SearchKeoGenerated: "".concat(exports.BDO_BASE_URL, "/WasteRecordCard/v1/Keo/KeoGenerated/search"),
    SearchKeoTreated: "".concat(exports.BDO_BASE_URL, "/WasteRecordCard/v1/Keo/KeoTreated/search"),
    SearchKeoForwarded: "".concat(exports.BDO_BASE_URL, "/WasteRecordCard/v1/Keo/KeoForwarded/search"),
    WasteTransferCard: "".concat(exports.BDO_BASE_URL, "/WasteTransferCard/v1/Kpo/transportconfirmation/card"),
    DocumentServiceKPOPrintingPage: "".concat(exports.BDO_BASE_URL, "/DocumentService/v1/kpo/printingpage"),
    DocumentServiceKPOConfirmation: "".concat(exports.BDO_BASE_URL, "/DocumentService/v1/kpo/confirmation"),
    DocumentServiceKEOPrintingPage: "".concat(exports.BDO_BASE_URL, "/DocumentService/v1/keo/printingpage"),
};
/**
 * Creates CarboWaste API endpoints with the given base URL
 */
var createCarboWasteEndpoints = function (baseUrl) { return ({
    HealthCheck: "".concat(baseUrl, "/api/health"),
    Subscription: "".concat(baseUrl, "/api/v1/Subscription"),
    Registration: "".concat(baseUrl, "/api/v1/Subscription/registration"),
    Unregistration: "".concat(baseUrl, "/api/v1/Subscription/unregister"),
    AddCompany: "".concat(baseUrl, "/api/v1/Subscription/addcompany"),
    UpdateCompany: "".concat(baseUrl, "/api/v1/Subscription/updatecompany"),
    DeleteCompany: "".concat(baseUrl, "/api/v1/Subscription/deletecompany"),
    FindCompany: "".concat(baseUrl, "/api/v1/Subscription/findcompany"),
    SendMessage: "".concat(baseUrl, "/api/v1/Contact/send"),
    StartSheet: "".concat(baseUrl, "/api/v1/Excel/startsheet"),
    WasteCodeList: "".concat(baseUrl, "/api/v1/Dictionary/wastecode"),
    WasteProcessList: "".concat(baseUrl, "/api/v1/Dictionary/wasteprocess"),
}); };
exports.createCarboWasteEndpoints = createCarboWasteEndpoints;
/**
 * CarboWaste webpage URL
 */
exports.CARBOWASTE_WEBPAGE_URL = "https://carbowaste.carbomath.com/carbowaste-bdo#how-to-subscribe";
/**
 * API retry configuration
 */
exports.API_RETRY_CONFIG = {
    TimeDelayInMs: 500,
    TryCount: 5,
};
//# sourceMappingURL=endpoints.js.map